module.exports = __webpack_public_path__ + "img/Home_2.9348d02a.gif";